import { render } from "./gaji-list.vue?vue&type=template&id=84b8d11a"
import script from "./gaji-list.vue?vue&type=script&lang=js"
export * from "./gaji-list.vue?vue&type=script&lang=js"

import "./gaji-list.vue?vue&type=style&index=0&id=84b8d11a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__